import { render, staticRenderFns } from "./CommentsPopup.vue?vue&type=template&id=3bd16122&scoped=true"
import script from "./CommentsPopup.vue?vue&type=script&lang=js"
export * from "./CommentsPopup.vue?vue&type=script&lang=js"
import style0 from "./CommentsPopup.vue?vue&type=style&index=0&id=3bd16122&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd16122",
  null
  
)

export default component.exports